import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as api from './companyAPI';
import KPConfig from '../../KPConfig.js'

const initialState = {
  data: { features: {} },
  billingData: {},
  initialCompanyInformation: {} //Used in CompanyInformation component
};

export const getUserCompany = createAsyncThunk(
  'company/get',
  async () => {
    let response;
    if (KPConfig.useNewBe) {
      response = await api.newGet();
    } else {
      response = await api.oldGet();
    }

    return response.body;
  },
  { condition: (opts) => {
    // This will be run before the pending reducer
    return !opts?.skipFetch;
  }}
);

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyName: (state,action) => {
      state.data.name = action.payload;
    },
    setCompanyInfo: (state, action) => {
      state.data.info = action.payload;
    },
    setCompanyLogo: (state, action) => {
      state.data.logo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserCompany.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getUserCompany.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
        state.initialCompanyInformation = 
        {
          name: action.payload.name,
          info: action.payload.info,
          logo: action.payload.logo
        };
      })
      .addCase(getUserCompany.rejected, (state) => {
        state.status = 'error';
      })
  }
});

// Destructure and export the plain action creators
export const {
  setCompanyName,
  setCompanyInfo,
  setCompanyLogo
} = companySlice.actions

export const selectFeatures = (state) => state.company.data.comp_features;
export const selectCompanyData = (state) => state.company.data;
export const selectCompanyName = (state) => state.company.data?.name;
export const selectCompanyInfo = (state) => state.company.data?.info;
export const selectCompanyLogo = (state) => state.company.data?.logo;
export const selectCompanyId = (state) => state.company.data?.id;
export const selectSubscriptionStatus = (state) => state.company.data.subscription_status;
export const selectInitialCompanyInformation = (state) => state.company.initialCompanyInformation;
export const selectSubscriptionCancelAtPeriodEnd = (state) => state.company.data.subscription_cancel_at_period_end;
export const selectHasOnlyCanceledSubscriptions = (state) => state.company.data.has_only_canceled_subscriptions;
export const selectSubscriptionPlanIdentifier = (state) => state.company.data.subscription_plan_identifier;

export default companySlice.reducer;
